import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import saltaireInstagram from './images/saltaire@fiferries.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Saltaire"
      meta={[
        { name: 'description', content: 'Saltaire is a residential community on Fire Island with great views.' },
        { name: 'keywords', content: 'Saltaire, Fire Island, New York, Long Island, Ferries, Water Taxi' },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Saltaire">
        <h2>Communities</h2>
        <h1>Saltaire</h1>
        <p>Amenities</p>
        <div className="amenities">
          { Amenities.byBeach('Saltaire').map(item => (
            <i key={item.text} className={`icon-${item.icon}`} title={item.text} />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="/schedules/saltaire">Schedules</Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">Directory</Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Saltaire</h1>
          </div>
          <p>
            The Incorporated Village of Saltaire is primarily a residential community.  
            It boasts a newly renovated market and liquor store at the center of the community, as well as a lending library and other amenities.  
            Besides these great amenities the Village of Saltaire has a softball fieldthat gives the community a place to play softball, baseball, soccer, and other summer time games. 
            During the summer months, there is a day camp where  kids can play games, swim in the bay or ocean, and participate in arts and crafts.
          </p>
        </div>
        <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="February 2, 2017" profile={fiferries} image={saltaireInstagram} link="https://www.instagram.com/p/BQCG9jtlbYA/?taken-by=fiferries" className="mx-auto" />
        </div>
      </div>
      <Tip title="Captain's Tip">
        Always have a flashlight for nighttime bike rides and proceed with caution in case of deer.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Saltaire is available by Fire Island Ferries from Bay Shore.  <Link to="/schedules/saltaire">Click here for schedules.</Link>
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is available to and from Saltaire during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
